import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";

import AppRoutes from './AppRoutes';
import { useAppContext } from '@context/AppContext';
import useRouteTracking from './hooks/useRouteTracking';
import AppInsightsErrorBoundary from '@components/AppInsightsErrorBoundary/AppInsightsErrorBoundary';
import Header from '@components/Header/Header';
import Sidebar from '@components/Sidebar/Sidebar';
import { jwtDecode } from "jwt-decode";


import './App.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@assets/icons/style.scss';


import logoTherapia from '@assets/images/logo-therapia.png';
import ModalConfirmCloseEdit from 'modals/modalConfirmCloseEdit/ModalConfirmCloseEdit';
import Version from '@components/Version/Version';

const App = () => {
  // Registra un PageView en AppInsights cada vez que cambia la ruta (RR v6)
  useRouteTracking();

  const [isMenuOpen, setIsMenuOpen] = useState(true);
  const { dispatch } = useAppContext();
  const { logout } = useKindeAuth();
  const navigate = useNavigate()
  const handleNavigate = useCallback(
    (url: string) => {
      navigate(url)
    } , [navigate]
  )
  const [ sections , setSections ] = useState<any>([])

  const [ menuLogout , setMenuLogout ] = useState({ codeMenu: 'closeSession' , name: 'Cerrar sesión' , icon: 'log-out4' })
  const [ helper , setHelper ] = useState({ codeMenu: 'helper' , name: 'Ayuda' , icon: 'question2' })
  const [ breadcrumb , setBreadcrumb ] = useState<any>([])
  const [editingPatient, setEditingPatient] = useState( false )
  const [ nextUrl , setNextUrl ] = useState( '' )
  const { state } = useAppContext();
  const { token } = state;

  useEffect(() => {
    if (!token) return;
    setSections((prevSections: any) => {
      if (prevSections && prevSections.length > 0) return prevSections;
      const tokenTEMP: any = jwtDecode(token);
      if (tokenTEMP.organization_properties.isfreseniusworkflow?.v === 'on') {
        let sectionsArr = []

        if ( tokenTEMP.roles ) {

          // Autorización
          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_system_admin' ||
                role.key === 'super-administrator' ||
                role.key === 'fresenius_autorization_admin' ||
                role.key === 'fresenius_autorization_basic'
              ) ) {
            sectionsArr.push(
              {
                name: 'Autorización',
                options: [
                  { codeMenu: 'compApplicationList', name: 'Listado de Preparados', icon: 'menu-11', active: false, route: '/compApplicationList' } ,
                  { codeMenu: 'reportList', name: 'Informe ISP', icon: 'pdf', active: false, route: '/reportList' }
                ]
              }
            )
          }
          
          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_system_admin' ||
                role.key === 'super-administrator' ||
                role.key === 'fresenius_autorization_reprint'
              ) ) {
            const autorizacionSection = sectionsArr.find((section: any) => section.name === 'Autorización');
            if (autorizacionSection) {
              autorizacionSection.options.push({ codeMenu: 'reprints', name: 'Reimpresiones', icon: 'print2', active: false, route: '/reprints' });
            } else {
              sectionsArr.push({
                name: 'Autorización',
                options: [
                  { codeMenu: 'reprints', name: 'Reimpresiones', icon: 'print2', active: false, route: '/reprints' }
                ]
              });
            }
          }

          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_system_admin' ||
                role.key === 'super-administrator' ||
                role.key === 'fresenius_autorization_reportInstitutional'
              ) ) {
            const autorizacionSection = sectionsArr.find((section: any) => section.name === 'Autorización');
            if (autorizacionSection) {
              autorizacionSection.options.push({ codeMenu: 'reportInstitutionalApplications', name: 'Solicitudes Institución', icon: 'pdf', active: false, route: '/reportInstitutionalApplications' });
            } else {
              sectionsArr.push({
                name: 'Autorización',
                options: [
                  { codeMenu: 'reportInstitutionalApplications', name: 'Solicitudes Institución', icon: 'pdf', active: false, route: '/reportInstitutionalApplications' } ,
                ]
              });
            }
          }

  
          // Bodega
          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_system_admin' ||
                role.key === 'super-administrator' ||
                role.key === 'fresenius_warehouse_admin' ||
                role.key === 'fresenius_warehouse_basic'
              ) ) {
            sectionsArr.push(
              {
                name: 'Bodega',
                options: [
                  { codeMenu: 'storeCampaingList', name: 'Listado de Campañas', icon: 'menu-11', active: false, route: '/storeCampaingList' },
                  { codeMenu: 'inventoryManagementReport', name: 'Gestión de Inventarios', icon: 'graph-9', active: false, route: '/inventoryManagementReport' }
                ]
              }
            )
          }
  
          // Elaboración
          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_system_admin' ||
                role.key === 'super-administrator' ||
                role.key === 'fresenius_elaboration_admin' ||
                role.key === 'fresenius_elaboration_basic'
              ) ) {
            sectionsArr.push(
              {
                name: 'Elaboración',
                options: [
                  { codeMenu: 'pickingList', name: 'Picking', icon: 'checklist', active: false, route: '/pickingList' },
                  { codeMenu: 'sanitationI', name: 'Sanitización I', icon: 'checklist', active: false, route: '/sanitationI' },
                  { codeMenu: 'sanitationII', name: 'Sanitización II', icon: 'checklist', active: false, route: '/sanitationII' },
                  { codeMenu: 'preElaboration', name: 'Pre-elaboración', icon: 'checklist', active: false, route: '/preElaboration' },
                  { codeMenu: 'production', name: 'Producción', icon: 'checklist', active: false, route: '/production' },
                  { codeMenu: 'postElaboration', name: 'Post-elaboración', icon: 'checklist', active: false, route: '/postElaboration' },
                  { codeMenu: 'labeled', name: 'Etiquetado', icon: 'checklist', active: false, route: '/labeled' }
                ]
              }
            )
          }
  
          // Control Procesos
          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_system_admin' ||
                role.key === 'super-administrator' || 
                role.key === 'fresenius_control_admin' ||
                role.key === 'fresenius_control_basic'
              ) ) {
            sectionsArr.push(
              {
                name: 'Control Procesos',
                options: [
                  { codeMenu: 'liberation', name: 'Liberación', icon: 'check-avances', active: false, route: '/liberation' },
                  { codeMenu: 'validationReport', name: 'Conciliación de Preparados', icon: 'graph-9', active: false, route: '/validationReport' },
                  { codeMenu: 'detectionsReport', name: 'Detecciones', icon: 'graph-9', active: false, route: '/detectionsReport' },
                  { codeMenu: 'preparationSheets', name: 'Hojas de Preparación', icon: 'graph-9', active: false, route: '/preparationSheets' },
                  { codeMenu: 'auditReport', name: 'Audit Trail', icon: 'graph-9', active: false, route: '/auditReport' } ,
                  { codeMenu: 'elaborationList', name: 'Listado de elaboración', icon: 'menu-11', active: false, route: '/elaborationList' },
                ]
              }
            )
          }
  
          // Facturación
          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_system_admin' ||
                role.key === 'super-administrator' || 
                role.key === 'fresenius_billing_admin' ||
                role.key === 'fresenius_billing_basic'
              ) ) {
            sectionsArr.push(
              {
                name: 'Facturación',
                options: [
                  { codeMenu: 'billing', name: 'Facturación', icon: 'paper-plane', active: false, route: '/billing' } ,
                  { codeMenu: 'prebilling', name: 'Listado para prefacturación', icon: 'menu-11', active: false, route: '/prebilling' } ,
                  { codeMenu: 'sendPDF', name: 'Envío PDF', icon: 'pdf', active: false, route: '/sendPDF' } ,
                  { codeMenu: 'printing', name: 'Impresiones', icon: 'print2', active: false, route: '/printing' }
                ]
              }
            )
          }

          // Conciliación
          // if ( tokenTEMP.roles.some( (role: any) =>
          //       role.key === 'fresenius_system_admin' ||
          //       role.key === 'super-administrator' || 
          //       role.key === 'fresenius_conciliation_admin'
          //     ) ) {
          //   sectionsArr.push(
          //     {
          //       name: 'Conciliación',
          //       options: [
          //         { codeMenu: 'conciliationPatient', name: 'Pacientes', icon: 'pdf', active: false, route: '/conciliationPatient' } ,
          //         { codeMenu: 'conciliationStore', name: 'Bodega', icon: 'pdf', active: false, route: '/conciliationStore' } ,
          //         { codeMenu: 'reportAutorization', name: 'Reporte Autorización', icon: 'pdf', active: false, route: '/reportAutorization' }
          //       ]
          //     }
          //   )
          // }
  
          // Mantenedores
          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_system_admin' ||
                role.key === 'super-administrator'
              ) ) {
            sectionsArr.push(
              {
                name: 'Mantenedores',
                options: [
                  { codeMenu: 'mantainerServices', name: 'Servicios', icon: 'configuration3', active: false, route: '/mantainerServices' },
                  { codeMenu: 'mantainerLaboratories', name: 'Laboratorios', icon: 'configuration3', active: false, route: '/mantainerLaboratories' },
                  { codeMenu: 'mantainerInfusionSets', name: 'Set de Infusión', icon: 'configuration3', active: false, route: '/mantainerInfusionSets' },
                  { codeMenu: 'mantainerSolutions', name: 'Vehículo', icon: 'configuration3', active: false, route: '/mantainerSolutions' },
                  { codeMenu: 'mantainerAdministrationRoutes', name: 'Vía de Administración', icon: 'configuration3', active: false, route: '/mantainerAdministrationRoutes' },
                  { codeMenu: 'mantainerLabels', name: 'Prioridad de Droga', icon: 'configuration3', active: false, route: '/mantainerLabels' },
                  { codeMenu: 'mantainerPrescriptionTypes', name: 'Tipo de Prescripción', icon: 'configuration3', active: false, route: '/mantainerPrescriptionTypes' },
                  { codeMenu: 'mantainerMixingCenters', name: 'Centro de Mezcla', icon: 'configuration3', active: false, route: '/mantainerMixingCenters' },
                  { codeMenu: 'mantainerPathologies', name: 'Patologías', icon: 'configuration3', active: false, route: '/mantainerPathologies' },
                  { codeMenu: 'mantainerProtocols', name: 'Protocolos', icon: 'configuration3', active: false, route: '/mantainerProtocols' },
                  { codeMenu: 'mantainerDrugs', name: 'Drogas', icon: 'configuration3', active: false, route: '/mantainerDrugs' },
                  { codeMenu: 'mantainerInstitutions', name: 'Instituciones', icon: 'configuration3', active: false, route: '/mantainerInstitutions' },
                  { codeMenu: 'mantainerUsuarios', name: 'Usuarios', icon: 'configuration3', active: false, route: '/mantainerUsuarios' }
                ]
              }
            )
          }
        }
        return sectionsArr
      } else {
        let sectionsArr: any = [
          {
            name: 'Institución',
            options: []
          }
        ];
        if ( tokenTEMP.roles ) {
          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_institution_admin' ||
                role.key === 'fresenius_institution_basic'
              ) ) {
            sectionsArr[0].options.push(
              { codeMenu: 'patient', name: 'Solicitud de Preparado', icon: 'doc7', active: false, route: '/searchPatient' }
            )
          }
  
          if ( tokenTEMP.roles.some( (role: any) =>
                role.key === 'fresenius_institution_admin' ||
                role.key === 'fresenius_institution_approver'
              ) ) {
            sectionsArr[0].options.push(
              { codeMenu: 'applicationList', name: 'Listado de Solicitud', icon: 'menu-11', active: false, route: '/applicationList' }
            )
          }
        }
        return sectionsArr;
      }
    });
  }, [token]);

  const changeOptionMenu = (codeMenu: string) => {
    const sectionsTEMP = sections.map((section: any) => ({
      ...section,
      options: section.options.map((option: any) => ({
        ...option,
        active: option.codeMenu === codeMenu,
      })),
    }));
  
    if (JSON.stringify(sectionsTEMP) !== JSON.stringify(sections)) {
      setSections(sectionsTEMP);
    }
  };

  const setNewBreadcrumb = ( newBreadcrumb: any ) => {
    let tokenTEMP: any = {};
    if ( token ) {
      tokenTEMP = jwtDecode(token)
    }
    const breadCrumbTEMP = [ { name: tokenTEMP.org_name , active: false } ]
    breadCrumbTEMP.push( newBreadcrumb )
    setBreadcrumb( breadCrumbTEMP )  
  }
  
  const handleSideBarClick = async (op: any) => {
    const editingPatient = localStorage.getItem( btoa('editingPatient') );
    if ( editingPatient ) {
      setEditingPatient( true )
      setNextUrl( op.route )
    } else if ( op.codeMenu === 'closeSession' ) {
      localStorage.removeItem( btoa('editingPatient') )
      await logout();
      dispatch({ type: 'LOGOUT' });
    } else {
      handleNavigate(op.route)
    }
  }

  const goToNextUrl = () => {
    setEditingPatient(false)
    localStorage.removeItem( btoa('editingPatient') )
    handleNavigate(nextUrl)
  }

  return (
    <>
      <Header options={ breadcrumb }/>
      <div className={`page-container ${isMenuOpen ? '':'sbar_collapsed' } `}>
        <Sidebar logo={logoTherapia} sections={sections} logout={menuLogout} handleClick={handleSideBarClick} help={helper} />
        <div className="main-content">
          <main>
            {/* ErrorBoundary captura excepciones no controladas de cualquier página
                y las reporta automáticamente a Application Insights */}
            <AppInsightsErrorBoundary>
              <AppRoutes setOptionMenu={changeOptionMenu} setBreadcrumb={setNewBreadcrumb} />
            </AppInsightsErrorBoundary>
          </main>
        </div>
      </div>
      {
        editingPatient && 
        <ModalConfirmCloseEdit handleAccept={ goToNextUrl } handleCancel={() => setEditingPatient(false)} />
      }
      <Version />
    </>
  );
}

export default App
